(function () {
  'use strict';
  var dialog = document.querySelector('[data-ob-quick-dialog]');
  if (!dialog) return;
  var activeTrigger = null;
  var cache = {};

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
    return new Intl.NumberFormat('en-CA', { style: 'currency', currency: currency }).format(cents / 100) + ' ' + currency;
  }

  function updateCartCount(count) {
    var legacyCount = document.querySelector('#CartCount');
    if (legacyCount) legacyCount.textContent = count;
    var customCount = document.querySelector('.ob-cart-count');
    var cartLink = document.querySelector('.ob-icon-link[href*="/cart"]');
    if (!customCount && cartLink && count > 0) {
      customCount = document.createElement('span');
      customCount.className = 'ob-cart-count';
      cartLink.appendChild(customCount);
    }
    if (customCount) { customCount.textContent = count; customCount.hidden = count < 1; }
    if (cartLink) cartLink.setAttribute('aria-label', 'Cart with ' + count + ' items');
  }

  function populate(product, url) {
    var image = dialog.querySelector('[data-ob-quick-image]');
    var variants = dialog.querySelector('[data-ob-quick-variants]');
    var form = dialog.querySelector('[data-ob-quick-form]');
    var unavailable = dialog.querySelector('[data-ob-quick-unavailable]');
    var add = dialog.querySelector('[data-ob-quick-add]');
    dialog.querySelector('[data-ob-quick-title]').textContent = product.title;
    dialog.querySelector('[data-ob-quick-price]').textContent = money(product.price);
    dialog.querySelector('[data-ob-quick-link]').href = url;
    dialog.querySelector('[data-ob-quick-feedback]').textContent = '';
    add.disabled = false;
    add.textContent = 'Add to cart';
    if (product.featured_image) {
      image.src = product.featured_image.indexOf('//') === 0 ? 'https:' + product.featured_image : product.featured_image;
      image.alt = product.title;
      image.hidden = false;
    } else image.hidden = true;

    variants.innerHTML = '';
    var selected = false;
    product.variants.forEach(function (variant) {
      var option = document.createElement('option');
      option.value = variant.id;
      option.textContent = variant.title + (variant.available ? '' : ' — Sold out');
      option.disabled = !variant.available;
      if (variant.available && !selected) { option.selected = true; selected = true; }
      variants.appendChild(option);
    });
    variants.hidden = product.variants.length === 1 && product.variants[0].title === 'Default Title';
    variants.previousElementSibling.hidden = variants.hidden;
    form.hidden = !product.available;
    unavailable.hidden = product.available;
  }

  function open(trigger) {
    if (window.matchMedia('(max-width: 767px)').matches) return;
    var handle = trigger.getAttribute('data-ob-quick-handle');
    var url = trigger.getAttribute('data-ob-quick-url') || '/products/' + handle;
    if (!handle) return;
    activeTrigger = trigger;
    document.body.classList.add('ob-quick-view-open');
    dialog.querySelector('[data-ob-quick-title]').textContent = 'Loading product…';
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    var request = cache[handle] ? Promise.resolve(cache[handle]) : fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Unable to load this product.'); return response.json(); })
      .then(function (product) { cache[handle] = product; return product; });
    request.then(function (product) {
      populate(product, url);
      dialog.querySelector('[data-ob-quick-close]').focus();
    }).catch(function () {
      dialog.querySelector('[data-ob-quick-title]').textContent = 'Unable to load this product';
      dialog.querySelector('[data-ob-quick-form]').hidden = true;
    });
  }

  function close() {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    document.body.classList.remove('ob-quick-view-open');
    if (activeTrigger) activeTrigger.focus();
    activeTrigger = null;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ob-quick-open]');
    if (trigger) { event.preventDefault(); open(trigger); return; }
    if (event.target.closest('[data-ob-quick-close]') || event.target === dialog) close();
  });
  dialog.addEventListener('close', function () { document.body.classList.remove('ob-quick-view-open'); });
  dialog.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-ob-quick-form]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var feedback = form.querySelector('[data-ob-quick-feedback]');
    button.disabled = true;
    feedback.textContent = 'Adding…';
    fetch(form.action + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (response) { if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add this item.'); }); return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (response) { return response.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); feedback.textContent = 'Added to cart.'; button.textContent = 'Added'; })
      .catch(function (error) { feedback.textContent = error.message; button.disabled = false; });
  });
})();
